// EkBharatShreshthaBharat
import React from 'react';

import EnglishCCAClass3to5 from 'views/EnglishCCAClass3to5';

const EkBharatShreshthaBharatPage = () => {
  return <EnglishCCAClass3to5 />;
};

export default EkBharatShreshthaBharatPage;